import React, { useEffect, useState } from 'react';
import { getVentilatorMode } from '../../helper/mode-helper';
import { TEMP_MODE } from '../../common/ENUMS/VENTILATOR_MODES_ENUM';
import { SET_PARAMETERS, PARAMETER_UNIT_IDS } from '../../common/ENUMS/PARAMETER_ENUM';
import { connect } from "react-redux";
import arrowUp from "../../common/images/arrow_up.png";
import arrowDown from "../../common/images/arrow_down.png";
import { USER_VIEW } from "../../common/constant/common-constants";
import VentilatorSetParamsDesktopView from "./VentilatorSetParamsDesktopView";
import VentilatorSetParamsMobileView from "./VentilatorSetParamsMobileView";

function VentilatorSetParams(props) {
    const [expanded, setExpanded] = useState(false);

    const setParams =
        props?.ventilatorPatientModeAlarmProfileData?.setParameters || [];

    const formatValue = (num) => {
        if (num == null || isNaN(num)) return "--";

        const truncated = num * 100;

        if (truncated % 100 === 0) {
            return num.toString();
        } else if (truncated % 10 === 0) {
            const numStr = num.toString();
            const [intPart, decPart] = numStr.split(".");
            return intPart + "." + (decPart ? decPart[0] : "0");
        } else {
            const numStr = num.toString();
            const [intPart, decPart] = numStr.split(".");
            return intPart + "." + (decPart ? decPart.slice(0, 2) : "00");
        }
    };

    // Common parameter transformation
    const parsedParams = setParams.map((item) => {
        const paramId = item?.[0];
        let paramValue = item?.[1];
        const paramUnit = item?.[2];

        const hasValidUnit =
            PARAMETER_UNIT_IDS?.[paramUnit]?.UNIT != null;

        if (hasValidUnit && paramValue !== null && !isNaN(paramValue)) {
            if (paramId === 100506) {
                paramValue =
                    paramValue <= 1
                        ? `1 : ${(1 / parseFloat(paramValue)).toFixed(1)}`
                        : `${parseFloat(paramValue).toFixed(1)} : 1`;
            } else {
                paramValue = formatValue(paramValue);
            }
        } else {
            paramValue = "--";
        }

        return {
            title: SET_PARAMETERS?.[paramId]?.TITLE ?? "-",
            value: paramValue,
            unit: hasValidUnit
                ? PARAMETER_UNIT_IDS?.[paramUnit]?.UNIT ?? "-"
                : "-"
        };
    });

    return (
        <>
            {props.config.userView === USER_VIEW.DESKTOP && (
                <VentilatorSetParamsDesktopView
                    expanded={expanded}
                    setExpanded={setExpanded}
                    params={parsedParams}
                />
            )}

            {props.config.userView === USER_VIEW.MOBILE && (
                <VentilatorSetParamsMobileView
                    expanded={expanded}
                    setExpanded={setExpanded}
                    params={parsedParams}
                />
            )}
        </>
    );
}

const mapStateToProps = (state, ownProps) => {
    let ventilatorPatientModeAlarmProfileData = state?.deviceVitalDataReducer?.ventilatorPatientModeAlarmProfileData?.[ownProps.bedId];
    // console.log("ventilatorPatientModeAlarmProfileData in set parameters------->", ventilatorPatientModeAlarmProfileData)

    return {
        ventilatorPatientModeAlarmProfileData: ventilatorPatientModeAlarmProfileData,
        config: state.configReducer.config
    }
}
export default connect(mapStateToProps, null)(VentilatorSetParams);